import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=a72fd082&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=ts"
export * from "./CategoryCard.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=a72fd082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72fd082",
  null
  
)

export default component.exports